<script>
    export default {
        name: "HomeAboutText",
        methods: {
            scrollTo() {
                const el = document.querySelector("#partners");
                const header = document.querySelector(".the-header");
                const headerHeight = header.getBoundingClientRect().height;

                const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
                window.scrollTo({
                    top,
                    behavior: "smooth",
                });
            },
        },
    };
</script>

<template>
    <div class="home-about-text">
        <h2 class="home-about-text__title">Электрическая мельница <span>FinaMill</span></h2>

        <div class="home-about-text__info">
            Полностью раскрывает яркий вкус специй&nbsp;&mdash; достаточно нажать одну кнопку.
            Секрет простоты и&nbsp;удобства&nbsp;&mdash; в&nbsp;контейнерах FinaPod. Они
            одновременно служат для хранения специй и&nbsp;для&nbsp;их&nbsp;помола
        </div>

        <button class="home-about-text__button" @click="scrollTo">Купить</button>
    </div>
</template>

<style lang="scss">
    .home-about-text {
        padding: 28px 32px;
        background-color: #9bb49c;
        @include bp($bp-desktop-sm) {
            flex-basis: 50%;
            max-width: 50%;
            padding: 36px;
            text-align: center;
        }
    }

    .home-about-text__title {
        margin-bottom: 16px;
        font-size: 24px;
        font-weight: 600;
        line-height: 31px;
        span {
            color: #fff;
        }
        @include bp($bp-desktop-sm) {
            max-width: 600px;
            margin: 0 auto 20px;
            font-size: 48px;
            line-height: 61px;
        }
    }

    .home-about-text__info {
        margin-bottom: 40px;
        font-family: var(--secondary-font);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        @include bp($bp-desktop-sm) {
            max-width: 525px;
            margin: 0 auto 40px;
            font-size: 16px;
            line-height: 26px;
        }
    }

    .home-about-text__button {
        width: 113px;
        color: var(--primary-text);
        font-family: var(--secondary-font);
        font-size: 12px;
        font-weight: 700;
        line-height: 43px;
        text-align: center;
        text-transform: uppercase;
        border: 2px solid var(--primary-text);
        border-radius: 5px;
        transition: background-color 0.2s ease-in, color 0.2s ease-in;
        &:hover {
            color: #fff;
            background-color: var(--primary-text);
        }
    }
</style>
